















































import Vue from 'vue';
import * as relazioneMedicaEventoApi from '../../services/relazione-medica-evento-api';
import {
    RelazioneMedicaEventoListViewModel,
    RelazioneMedicaEvento,
} from '../../types';

import relazioneMedicaEventoEdit from '@/components/commands/RelazioneMedicaEventoEdit.vue';

export default Vue.extend({
    components: {},
    props: {
        relazioneMedicaId: { required: true, type: Number },
    },
    data(): RelazioneMedicaEventoListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.data-evento'),
                    value: 'dataEvento',
                    width: 200,
                },
                {
                    text: this.$i18n.t('labels.note'),
                    value: 'note',
                },
            ],
            dataItems: [],
            selectedItems: [],
            dialog: false,
            editComponent: relazioneMedicaEventoEdit,
            currentEditId: undefined,
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await relazioneMedicaEventoApi.getByRelazioneMedica(
                this.relazioneMedicaId
            );
            this.selectedItems = [];
        },
        showDetail(item: RelazioneMedicaEvento) {
            this.currentEditId = item.id;
            this.dialog = true;
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await relazioneMedicaEventoApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
        getComponentProps() {
            return {
                relazioneMedicaId: this.relazioneMedicaId,
                id: this.currentEditId,
            };
        },
        dialogClose() {
            this.currentEditId = undefined;
            this.dialog = false;
        },
    },
    async mounted() {
        await this.loadData();
    },
});
